<template>
  <div>
    <div v-if="isMe && $store.state.edit.on" style="position: relative">
      <BaseSingleSelect
        :selected-in="selected"
        :options="options"
        close-on-selection
        @change="selectOption"
      />
      <i :class="{ pullup: loading }" style="margin-top: -10px">
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <NetworkLoader :loader="loading" :failed="failed" />
      </i>
    </div>
    <div v-else>
      <span>{{ $t(options[selected]) }}</span>
    </div>
  </div>
</template>

<script>
import { SET_EDIT_UNSAVED, UPDATE_USER_STATE } from '@/state/mutation-types'
import { SET_EDIT_SAVING_STATE, UPDATE_USER_EXPERIENCE } from '@/state/action-types'
import BaseSingleSelect from '@/components/BaseSingleSelect.vue'

export default {
  name: 'ComponentEditDropdown',
  components: { BaseSingleSelect },
  props: {
    isMe: {
      type: Boolean,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    selectedIn: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    subSelector: {
      type: String,
      required: false,
      default: null,
    },
    revertOnFail: {
      type: Boolean,
      required: false,
      // eslint-disable-next-line vue/no-boolean-default -- Baseline eslint ignore please fix if working on this
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      failed: false,
      selected: '',
    }
  },
  watch: {
    loading(saving) {
      this.$store.commit(SET_EDIT_UNSAVED, saving)
      this.$store.dispatch(SET_EDIT_SAVING_STATE, saving)
    },
  },
  created() {
    this.selected = this.selectedIn
  },
  methods: {
    selectOption(key) {
      this.selected = key
      this.$emit('change', this.selected)
      this.failed = false
      this.loading = true
      this.$store.commit(UPDATE_USER_STATE, {
        fieldName: this.fieldName,
        fieldValue: key,
      })
      this.saveChanges()
    },
    async saveChanges() {
      this.loading = true
      await this.$store.dispatch(UPDATE_USER_EXPERIENCE, this.account.globalId)
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.dropdown-toggle {
  border: none;
}
i {
  position: absolute;
  margin-left: 5px;
}
.pullup {
  margin-top: -7px;
}
</style>
